import styled from "styled-components";
import { lighten } from "polished";

import theme from "config/theme";

import { H4 } from "components/Text";
import StyledImage from "components/Image";
import { Wrapper as ButtonSimple } from "components/Button/ButtonSimple/styles";

export const Wrapper = styled.a`
  display: block;
  text-align: left;
  margin: 5px;
  transition: ${theme.transition};
  border-radius: ${theme.radius};
  overflow: hidden;
  background-color: ${lighten(0.05, theme.color.gray)};

  &:hover {
    transform: scale(0.98) translateZ(0);
    background-color: ${lighten(0.06, theme.color.gray)};

    ${ButtonSimple} {
      color: ${theme.color.primary};
    }
  }
`;

export const Inner = styled.div`
  width: 100%;
  padding: 25px;
`;

export const Title = styled(H4)`
  color: white;
  line-height: 1.3;
  margin-bottom: 5px;
  font-size: ${theme.font.size.delta};
`;

export const Description = styled.div`
  margin-bottom: 25px;
  line-height: 1.3;

  h3,
  figure,
  blockquote {
    display: none;
  }

  p {
    margin: 0;
    display: inline;
  }

  * {
    font-style: normal;
    color: ${theme.color.gray4};
    font-size: ${theme.font.size.zeta};
    font-weight: ${theme.font.weight.regular};
  }
`;

export const Image = styled(StyledImage)`
  width: 100%;
  display: block;
`;
